import React from 'react';
import * as PropTypes from 'prop-types';

import { Wrapper } from './elements';

function Wra16D(props) {
  return (
    <Wrapper
      className={props.className}
      onClick={props.onClick}
      style={props.style}
    >
      {props.children}
    </Wrapper>
  );
}

Wra16D.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};

export default Wra16D;
